import React from "react";
import ReactApexChart from "react-apexcharts";

function Seller_pie_chart({ sellerData, sellerCount }) {
  class ApexChart extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        series: sellerCount,
        options: {
          chart: {
            type: "pie",
          },
          labels: sellerData,
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      };
    }

    render() {
      return (
        <div>
          <div id="chart">
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="pie"
            />
          </div>
          <div id="html-dist"></div>
        </div>
      );
    }
  }

  return <ApexChart />;
}

export default Seller_pie_chart;
